import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-flag-subscription-modal',
  templateUrl: './flag-subscription-modal.component.html',
  styleUrls: ['./flag-subscription-modal.component.scss']
})
export class FlagSubscriptionModalComponent implements OnInit {

  @Input() requestId: number;
  public event: EventEmitter<{requestId: number, cancellationReason: string}> = new EventEmitter();
  public flaggingForm: FormGroup;
  public actionLabel: string;

  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.flaggingForm = this.formBuilder.group({
      flaggingReason: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          this.noWhitespaceValidator
        ]
      ],
    });
  }

  handleModalHide(): void {
    this.bsModalRef.hide();
  }

  onContinueEvent(): void{
    this.event.emit({requestId: this.requestId, ...this.flaggingForm.value});
  }

  checkSubmitDisable(): boolean {
    return this.flaggingForm.invalid;
  }

  public noWhitespaceValidator(control: FormControl): { whitespace: true } {
    return (control.value || '').trim().length ? null : { whitespace: true };
  }
}
